export default __webpack_public_path__ + "static/media/BuckeyeLeaf-Scarlet.74dcdcec.svg";